<template>
    <div class="input" v-bind:class="{['input-'+width]: width, ['textalign-'+textalign]: textalign}" v-if="type=='textarea'">
        <label class="" v-if="label">{{label}}</label>
        <textarea :placeholder="placeholder" :disabled="disabled" @focus="$emit('focus')"  v-model="val"></textarea>
    </div>
    <div class="input tags-input" v-bind:class="{['input-'+width]: width, ['textalign-'+textalign]: textalign}" v-else-if="type=='tags'" @keyup.delete="deleteTag" @keyup.space="addTag" @keyup.enter="addTag">
        <label class="" v-if="label">{{label}}</label>
        <div class="tags-wrap">
            <div class="tags to-validate">
                <span class="tag tag-active" v-for="(tag, index) in tags" :key="index" v-bind:class="{'to-delete': tag.deleting, 'to-error': tag.isError}">{{tag.value}}<svgicon name="cross" @click.native="deleteTagInstantly(index)"/></span>
                <span class="tag tag-input"><input type="text" class="new-tag-input" placeholder="Email adress..." v-model="tagToAdd" v-on:change="addTag" /></span>
            </div>
        </div>
    </div>
    <div class="input image-input" v-bind:class="{['input-'+width]: width}" v-else-if="type=='image'">
        <label>
            <input id="image-file" type="file" accept=".jpg, .png, .jpeg"  name="image-file" class="imageinput" />
        <svgicon name="image" width="3rem" height="3rem"></svgicon></label>
    </div>
    <div class="input file-input" v-bind:class="{['input-'+width]: width}" v-else-if="type=='file'">
        <input type="file" name="file" id="file" class="inputfile" />
        <label for="file">Kies een bestand</label>
    </div>
    <div class="input avatar-input" v-bind:class="{['input-'+width]: width}" v-else-if="type=='avatar'">
        <input id="avatar-file" type="file" name="image-file" class="image-input" />
        <label for="avatar-file"><Avatar size="xxxl"><slot></slot></Avatar><div class="edit-avatar"><div class="flex-content"><div class="width-100 relative text-center"><svgicon name="edit"></svgicon></div></div></div></label>
    </div>
    <div class="input avatar-input" v-bind:class="{['input-'+width]: width}" v-else-if="type=='avatar-modal'">
        <div class="avatar-wrap"><Avatar size="xxxl">
            <slot></slot>
        </Avatar><div class="edit-avatar"><div class="flex-content"><div class="width-100 relative text-center"><svgicon name="edit"></svgicon></div></div></div></div>
    </div>
    <div class="input toggle-input" v-bind:class="{['input-'+width]: width}" v-else-if="type=='toggle'">
        <label class="switch">
            <input type="checkbox" @focus="$emit('focus')" checked>
            <span class="slider round"></span>
        </label>
    </div>
    <div class="input checkbox-input" v-bind:class="{['input-'+width]: width}" v-else-if="type=='checkbox'">
        <label class="checkbox" v-bind:class="{'float-left': label}">
            <input type="checkbox"  v-model="val"/>
            <span class="checkmark"></span>
            <div class="checkbox-label float-left">{{label}}</div>
        </label>
    </div>
    <div class="input radio-input" v-bind:class="{['input-'+width]: width}" v-else-if="type=='radio'">
        <label class="radio" v-bind:class="{'float-left': label}">
            <input type="radio" @focus="$emit('focus')" v-model="val"/>
            <span class="checkmark"></span>
        </label>
        <div class="radio-label float-left">{{label}}</div>
    </div>
    <div class="input" v-bind:class="{['input-'+width]: width}" v-else-if="type=='select'">
        <label class="" v-if="label">{{label}}</label>
        <select  v-model="val">
            <slot></slot>
        </select>
    </div>
    <div class="input" v-bind:class="{['input-'+width]: width, ['textalign-'+textalign]: textalign, 'is-invalid': invalid}" v-else>
        <label class="" v-if="label">{{label}}</label>
        <input :id="id" :type="type" :placeholder="placeholder" v-model="val" :disabled="disabled" @focus="$emit('focus')"/>
        <div class="error-message-wrap" v-if="errormessage">{{errormessage}}</div>
    </div>
</template>
<script>
    import Avatar from "../../components/Avatar/Avatar";
    import email from 'vuelidate/src/validators/email';

    export default {
        name: 'Input',
        components: {
            Avatar,
        },
        props: {
            label: {
                type: String
            },
            placeholder: {
                type: String
            },
            state: {
                type: String
            },
            value: {
            },
            width: {
                type: String,
                default: 'expand'
            },
            id: {
                type: String
            },
            type: {
                type: String,
                default: 'text'
            },
            textalign: {
                type: String,
                default: 'left'
            },
            disabled: {
                type: Boolean,
                default: false
            },
            invalid: {
                type: Boolean,
                default: false
            },
            errormessage: {
                type: String,
            },
            checked: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                tagToAdd: '',
                tags: null
            }
        },
        watch: {
            tags: function (val, oldVal) {
                if(oldVal!==null) {
                    this.$emit('input', val.map(tag => {
                        return tag.value
                    }));
                }
            },
        },
        computed: {
            val: {
                // getter
                get: function () {
                    return this.value
                },
                // setter
                set: function (newValue) {
                    this.$emit('input', newValue);
                }
            }
        },
        mounted () {
            if(this.type=="tags") {
                this.tags = this.value.map(value => {
                    return {value: value, deleting: false}
                })
            }
        },
        methods: {
            addTag: function() {
                if (this.tagToAdd.replace(/\s/g, '').length){
                    if (this.tags.length > 0) {
                        this.tags[this.tags.length - 1].deleting = false;
                    }
                    var tag = this.tagToAdd.replace(/\s/g, '');
                    this.tags.push({value: tag, deleting: false, isError: !email(tag)});
                    this.tagToAdd = '';
                    this.$forceUpdate();
                }
            },
            deleteTag: function() {
                if(this.tagToAdd < 1 && this.tags.length > 0) {
                    //check if input is empty
                    if (this.tags[this.tags.length - 1].deleting == false) {
                        this.tags[this.tags.length - 1].deleting = true;
                    } else {
                        this.tags.pop();
                    }
                }
            },
            deleteTagInstantly: function(index) {
                this.tags.splice(index, 1);
                this.$forceUpdate();
            }
        }
    }

</script>
<style src="./Input.scss" lang="scss"></style>

